import { getDurationInDays } from '@airasia-common/libraries/datetime';
import { FILTER_TO_HOTEL_SEARCH_RESULTS } from '@airasia-common/libraries/constants';
import { mapHotelListingUrlParamsToFilterState } from '@airasia-hotels/core/ParamFilter';
import Cookies from 'js-cookie';
import withSearchParams from '../withSearchParams';
import { UHF_LOCALE_NAME, UHF_CURRENCY_NAME } from '../../utils/constants';

const mapUrlParamsToFilterState = urlParams => {
  urlParams.languageId = urlParams.languageId || Cookies.get(UHF_LOCALE_NAME);
  urlParams.currency = urlParams.currency || Cookies.get(UHF_CURRENCY_NAME);

  return mapHotelListingUrlParamsToFilterState(urlParams);
};

const mapFilterStateToUrlParams = filter => {
  const lemonAgent = filter.lemonAgentId
    ? { lemon_agent_id: filter.lemonAgentId }
    : {};
  return {
    fromDate: filter.checkin,
    toDate: filter.checkout,
    destination: filter.locationId,
    rooms: filter.roomsCount,
    adults: filter.adults,
    children: filter.children,
    countryCode: filter.countryCode,
    languageId: filter.languageId,
    currency: filter.currency,
    days: getDurationInDays(filter.checkin, filter.checkout),
    sort: FILTER_TO_HOTEL_SEARCH_RESULTS[filter.sortBy],
    F_R: filter.guestRating,
    aaId: filter.aaId,
    applyBigpoints: filter.applyBigpoints,
    amenity: filter.amenity,
    hotelClass: filter.hotelClass,
    paymentType: filter.paymentType,
    propertyType: filter.propertyType,
    ...lemonAgent,
  };
};

export default withSearchParams(
  mapUrlParamsToFilterState,
  mapFilterStateToUrlParams
);
